export function joinUrl(base: string | undefined, path: string): string {
  if (!base) throw new Error(`joinUrl: base URL is undefined — check env vars (path: "${path}")`);
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
